require('../../modules/es.string.starts-with');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'startsWith');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/starts-with.js
// module id = 1232
// module chunks = 1